"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkApiErrors = checkApiErrors;
exports.getInputStateByField = getInputStateByField;
exports.mergeSchemas = exports.isNumber = void 0;
exports.setCaretPosition = setCaretPosition;
exports.setInputState = setInputState;
exports.setInputStateAsOptional = setInputStateAsOptional;
exports.setValidationMessage = setValidationMessage;
exports.validateAsciiOnly = validateAsciiOnly;
exports.validateAtLeastOneNumber = validateAtLeastOneNumber;
exports.validateCapitalAndLowerLetter = validateCapitalAndLowerLetter;
exports.validateCharacterCount = validateCharacterCount;
exports.validateIsRequired = validateIsRequired;
exports.validateNameMatch = validateNameMatch;
exports.validatePasswordLength = validatePasswordLength;
exports.validateTaxNumber = validateTaxNumber;
exports.validateVatNumber = validateVatNumber;
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var VALIDATION_DEFAULT_CONFIG = {
  pending: false
};
function validatePasswordLength(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
  if (!value) {
    return false;
  }
  return !!value && value.length >= min && value.length <= max;
}
function validateAtLeastOneNumber(value) {
  if (!value) {
    return false;
  }
  return !!(value && value.match(/\d/));
}
function validateCapitalAndLowerLetter(value) {
  if (!value) {
    return false;
  }
  var hasLower = value.toUpperCase() !== value;
  var hasUpper = value.toLowerCase() !== value;
  return hasLower && hasUpper;
}
function validateIsRequired(value) {
  if (!value) {
    return false;
  }
  return !!value;
}
function validateCharacterCount(value) {
  if (!value) return false;
  var frequencies = {};
  value.split('').forEach(function (char) {
    frequencies[char] = (frequencies[char] || 0) + 1;
  });
  var maxAllowedCount = value.length / 2;
  return !Object.values(frequencies).find(function (count) {
    return count > maxAllowedCount;
  });
}
function validateNameMatch(value, name) {
  return !!(value && (!name || name && value.toLowerCase().indexOf(name.toLowerCase().trim()) === -1));
}
function validateAsciiOnly(value) {
  if (!value) {
    return false;
  }
  return !!(value && value.match(/^[!-~]*$/));
}

// sets the cursor/caret position
function setCaretPosition(ctrl, pos) {
  // Modern browsers
  if (ctrl.setSelectionRange) {
    ctrl.focus();
    ctrl.setSelectionRange(pos, pos);

    // IE8 and below
  } else if (ctrl.createTextRange) {
    var range = ctrl.createTextRange();
    range.collapse(true);
    range.moveEnd('character', pos);
    range.moveStart('character', pos);
    range.select();
  }
}
function validateVatNumber(value) {
  return !!(value && value.match(/^[DE]+\d{0,9}$/));
}
function validateTaxNumber(value) {
  return !!(value && value.match(/^[0-9/]+$/));
}
function setInputState(error, touched) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : VALIDATION_DEFAULT_CONFIG;
  if (opts.pending) {
    return _reactSharedUiNext.InputState.PENDING;
  }
  if (touched && error) {
    return _reactSharedUiNext.InputState.ERROR;
  }
  if (touched && !error) {
    return _reactSharedUiNext.InputState.VALID;
  }
  return _reactSharedUiNext.InputState.NONE;
}
function setInputStateAsOptional(error, touched, hasValue) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : VALIDATION_DEFAULT_CONFIG;
  var state = setInputState(error, touched, opts);
  if (!hasValue) {
    return state === _reactSharedUiNext.InputState.VALID ? _reactSharedUiNext.InputState.NONE : state;
  }
  return state;
}

/**
 * merge validation schemas from different components so that they stay by the component
 * @param schemas {object} comma separated list of schemas
 * @returns {object} merged schema to use
 */
var mergeSchemas = exports.mergeSchemas = function mergeSchemas() {
  for (var _len = arguments.length, schemas = new Array(_len), _key = 0; _key < _len; _key++) {
    schemas[_key] = arguments[_key];
  }
  var first = schemas[0],
    rest = schemas.slice(1);
  var merged = rest.reduce(function (mergedSchemas, schema) {
    return mergedSchemas.concat(schema);
  }, first);
  return merged;
};

/**
 * helper returning inputState
 * @param field {string} name of the field to check
 * @param errors {object} error object from formik
 * @param touched {object} touched object from formik
 * @param opts {opts} option argument to use for additional config
 * @returns {number} inputState from  shared-ui
 */
function getInputStateByField(field) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var touched = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var opts = arguments.length > 3 ? arguments[3] : undefined;
  return setInputState(errors[field], touched[field], opts);
}

/**
 * logic what message to show
 * @param fieldInputState {number} inputState from  shared-ui
 * @param error {string} error message to show
 * @param pending {string} pending message rendered as hint if input in pending state
 * @returns {string} message to display
 */
function setValidationMessage(fieldInputState) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var pending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var msg = '';
  if (fieldInputState === _reactSharedUiNext.InputState.ERROR) {
    msg = error;
  } else if (fieldInputState === _reactSharedUiNext.InputState.PENDING) {
    msg = pending;
  }
  return msg;
}

/**
 * find error in api error bundle by name
 * @param name
 * @param errors
 * @returns {any}
 */
function checkApiErrors(name) {
  var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.entries(errors).length !== 0 ? !Object.keys(errors).find(function (x) {
    return x === name;
  }) : true;
}

/**
 * restricts possible characters that can be entered in the input
 * here only numbers are possible (business partner id, contractaccount number)
 * @param event keypress event
 * @returns {boolean}
 */
var isNumber = exports.isNumber = function isNumber(event) {
  var charCode = event.which ? event.which : event.keyCode;
  if (charCode === 8 || event.metaKey || event.ctrlKey) {
    return true;
  }
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }
  return true;
};